<template>
  <section id="Categoria" class="categorias">
   
    <h2 class="titulo">📚 Categorías</h2>

    <div class="grid-categorias">
      <div
        v-for="(categoria, index) in categorias"
        :key="index"
        class="card-categoria"
      >
        <img :src="categoria.icono" :alt="categoria.titulo" class="icono" />
        <h3 class="card-titulo">{{ categoria.titulo }}</h3>
        <p class="card-descripcion">{{ categoria.descripcion }}</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CategoriasJuegos',
  data() {
    return {
  categorias: [
  {
    titulo: 'PC Gaming',
    icono: require('@/assets/icons/pcgaming.png'),
    descripcion: 'Configuraciones, optimización y hardware recomendado para jugar en PC con alto rendimiento.'
  },
  {
    titulo: 'Consolas',
    icono: require('@/assets/icons/consolas.png'),
    descripcion: 'Guías y noticias sobre PlayStation, Xbox y Nintendo Switch. Comparativas y recomendaciones.'
  },
  {
    titulo: 'Mantenimiento PlayStation',
    icono: require('@/assets/icons/playstation-tools.png'),
    descripcion: 'Servicios de limpieza, cambio de pasta térmica, revisión de ventiladores y solución de errores comunes en consolas PS4 y PS5.'
  },
  {
    titulo: 'Reparación Nintendo Switch',
    icono: require('@/assets/icons/switch-repair.png'),
    descripcion: 'Diagnóstico y reparación de Joy-Con, pantalla, batería y problemas de software en Nintendo Switch.'
  }
]

    }
  }
}

</script>

<style scoped>
.categorias {
  background: url('@/assets/Img/Banners/computacion.jpg') no-repeat center center;
  background-size: cover;
  padding: 3rem 2rem;
  color: #fff;
  text-align: center;
}


.titulo {
  font-size: 2.5rem;
  margin-bottom: 2rem;
  font-weight: bold;
  color: #ffffff;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);
  animation: fadeInDown 1s ease-in-out;
}

.grid-categorias {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: auto;
}

.card-categoria {
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  transition: transform 0.4s ease, box-shadow 0.4s ease;
  color: #333;
  display: flex;
  flex-direction: column;
  align-items: center;
  opacity: 0;
  animation: fadeInUp 1s ease forwards;
}

.card-categoria:nth-child(1) { animation-delay: 0.1s; }
.card-categoria:nth-child(2) { animation-delay: 0.2s; }
.card-categoria:nth-child(3) { animation-delay: 0.3s; }
.card-categoria:nth-child(4) { animation-delay: 0.4s; }
.card-categoria:nth-child(5) { animation-delay: 0.5s; }
.card-categoria:nth-child(6) { animation-delay: 0.6s; }
.card-categoria:nth-child(7) { animation-delay: 0.7s; }
.card-categoria:nth-child(8) { animation-delay: 0.8s; }

.card-categoria:hover {
  transform: translateY(-8px) scale(1.05);
  box-shadow: 0 12px 32px rgba(0, 242, 255, 0.4);
}

/* ✅ Efecto zoom al pasar el mouse sobre el icono */
.icono {
  width: 80px;
  height: 80px;
  margin-bottom: 1rem;
  object-fit: contain;
  transition: transform 0.4s ease;
}

.card-categoria:hover .icono {
  transform: scale(1.2) rotate(5deg);
}

.card-titulo {
  font-size: 1.2rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  text-align: center;
}

.card-descripcion {
  font-size: 0.95rem;
  text-align: center;
  line-height: 1.4;
}

/* Animaciones */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
